import PropTypes from 'prop-types';

const MyProfilePropType = {
  example: PropTypes.string,
  isAdminView: PropTypes.bool,
};

export default MyProfilePropType;
